import { CoreFieldProps, fieldTypes } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";
import "./ComplexFields.scss";
import { PersonalAccountAcceptableUse } from "@/types/PersonalAccountAcceptableUse";
import { FinancialProduct } from "../SelectProductForm/FinancialProductCard";

export interface PersonalAccountAcceptableUseComplexValue {
  showHeader?: boolean;
  selectedPersonalProducts?: FinancialProduct[];
}

export interface PersonalAccountAcceptableUseComplexFieldProps
  extends fieldTypes.BaseFieldProps<PersonalAccountAcceptableUse> {}

export const PersonalAccountAcceptableUseComplexField: FC<
  PersonalAccountAcceptableUseComplexFieldProps
> = (props) => {
  const personalAccountAcceptableUseComplexValue =
    props.complexFieldValue as PersonalAccountAcceptableUseComplexValue;
  const selectedPersonalProducts =
    personalAccountAcceptableUseComplexValue?.selectedPersonalProducts || [];

  // Sort products alphabetically by title
  const sortedProducts = [...selectedPersonalProducts].sort((a, b) =>
    a.title.localeCompare(b.title)
  );

  return (
    <section className="complex-field-container personal-account-acceptable-use">
      {personalAccountAcceptableUseComplexValue?.showHeader && <h4>{props.label}</h4>}

      {sortedProducts.length > 0 && (
        <div className="applies-to-accounts-box">
          <strong>The below questions apply to the following accounts:</strong>
          <ul>
            {sortedProducts.map((product) => (
              <li key={product.id}>{product.title}</li>
            ))}
          </ul>
        </div>
      )}

      <div className="complex-field-content">
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.PERSONAL_ACCOUNT_ACCEPTABLE_USE.FOR_BUSINESS}
          complexFieldProps={
            {
              showClearButton: true,
            } as Partial<CoreFieldProps>
          }
        />
        {/* <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.PERSONAL_ACCOUNT_ACCEPTABLE_USE.CASH_DEPOSITS}
          complexFieldProps={
            {
              showClearButton: true,
            } as Partial<CoreFieldProps>
          }
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.PERSONAL_ACCOUNT_ACCEPTABLE_USE.SEND_RECEIVE_WIRES}
          complexFieldProps={
            {
              showClearButton: true,
            } as Partial<CoreFieldProps>
          }
        /> */}
      </div>
    </section>
  );
};
